import React from 'react';
import { Box, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { CloseIcon } from '@components/common/icon/common/CloseIcon';
import { useTranslation } from 'react-i18next';
import { theme } from '@style/theme';

interface ModalProps {
  title: string;
  open: boolean;
  onClose: (open: boolean) => void;
  children: React.ReactNode;
  maxWidth?: string;
  maxHeight?: string;
  style?: React.CSSProperties;
  dialogContentStyle?: React.CSSProperties;
}

const Modal: React.FC<ModalProps> = ({
  title,
  open,
  onClose,
  children,
  maxWidth = '900px',
  maxHeight,
  style,
  dialogContentStyle,
}) => {
  const { t } = useTranslation();

  const handleClose = () => onClose(false);

  return (
    <Dialog
      open={open}
      disableEnforceFocus
      disableRestoreFocus
      onClose={handleClose}
      PaperProps={{
        sx: {
          maxWidth,
          maxHeight,
          ...style,
        },
      }}
    >
      <DialogContent
        sx={{ display: 'flex', flexDirection: 'column', ...dialogContentStyle }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <DialogTitle
            style={{
              whiteSpace: 'normal',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              wordWrap: 'break-word',
              maxWidth: '85%',
            }}
            variant='h5'
            color={theme.colors.textDark}
          >
            {t(title)}
          </DialogTitle>
          <Box>
            <IconButton className='close-icon' onClick={handleClose} sx={{ right: 8 }}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default Modal;
